<template>
  <div
    v-if="options.countPag > 0"
    class="grid justify-center sm:flex sm:justify-end sm:items-center gap-2"
    >
    <!-- Pagination -->
    <nav class="flex justify-end items-center -space-x-px">
      <template v-if="options.pag > 1">
        <button
          type="button"
          class="cursor-pointer min-w-8 py-2 px-2 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-full last:rounded-e-full border border-gray-400 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-700 dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
          @click="onClickPage(options.pag - 1)" >
          <ChevronLeftIcon class="shrink-0 size-3.5" />
        </button>
        <div class="hs-tooltip inline-block border border-gray-400 dark:border-gray-700">
          <button
            type="button"
            class="cursor-pointer hs-tooltip-toggle group min-h-7.5 min-w-7.5 flex justify-center items-center text-gray-400 hover:text-blue-600 p-1 text-sm focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-500 dark:hover:text-blue-500 dark:focus:bg-white/10"
            @click="onClickPage(1)"
            >
            <span class="group-hover:hidden text-[10px]">•••</span>
            <ChevronDoubleLeftIcon class="group-hover:block hidden shrink-0 size-5" />
          </button>
        </div>
      </template>
      <template v-if="options.countPag <= 8 && options.pag <= 8">
        <button  v-for="i in options.countPag" :key="i" type="button" :class="options.pag == i ? classActive : classInactive" @click="onClickPage(i)"
          >{{ i }}</button>
      </template>
      <template v-else-if="options.pag < 8 && !(options.pag >= (options.countPag - 8))">
        <button
          v-for="i in 8" :key="i"  type="button" :class="options.pag == i ? classActive : classInactive"
          @click="onClickPage(i)">{{ i }}</button>
      </template>
      <template v-if="options.countPag > 8 && options.pag > 7 && options.pag <= (options.countPag - 8)">
        <button  type="button" :class="classInactive" @click="onClickPage(options.pag - 2)">{{ options.pag - 2
          }}</button>
        <button  type="button" :class="classInactive" @click="onClickPage(options.pag - 1)">{{ options.pag - 1
          }}</button>
        <div class="hs-tooltip inline-block border border-gray-400 dark:border-gray-700">
          <button
            type="button"
            class="disable hs-tooltip-toggle group min-h-7.5 min-w-7.5 flex justify-center items-center text-gray-400 hover:text-blue-600 p-1 text-sm focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-500 dark:hover:text-blue-500 dark:focus:bg-white/10">
            <span class="text-[10px]">•••</span>
          </button>
        </div>
        <button  type="button" :class="classActive" @click="onClickPage(options.pag)">{{ options.pag }}</button>
        <div class="hs-tooltip inline-block border border-gray-400 dark:border-gray-700">
          <button
            type="button"
            class="disable hs-tooltip-toggle group min-h-7.5 min-w-7.5 flex justify-center items-center text-gray-400 hover:text-blue-600 p-1 text-sm focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-500 dark:hover:text-blue-500 dark:focus:bg-white/10">
            <span class="text-[10px]">•••</span>
          </button>
        </div>
        <button  type="button" :class="classInactive" @click="onClickPage(options.pag + 1)">{{ options.pag + 1
          }}</button>
        <button  type="button" :class="classInactive" @click="onClickPage(options.pag + 2)">{{ options.pag + 2
          }}</button>
      </template>

      <template v-if="options.countPag > 8 && options.pag > (options.countPag - 8)">
        <button
          v-for="i in ultimos" :key="i"  type="button" :class="options.pag == i ? classActive : classInactive"
          @click="onClickPage(i)">{{ i }}</button>
      </template>
      <template v-if="options.countPag != options.pag">
        <div class="hs-tooltip inline-block border border-gray-400 dark:border-gray-700">
          <button
            type="button"
            class="cursor-pointer hs-tooltip-toggle group min-h-7.5 min-w-7.5 flex justify-center items-center text-gray-400 hover:text-blue-600 p-1 text-sm focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-gray-500 dark:hover:text-blue-500 dark:focus:bg-white/10"
            @click="onClickPage(options.countPag)">
            <span class="group-hover:hidden text-[10px]">•••</span>
            <ChevronDoubleRightIcon class="group-hover:block hidden shrink-0 size-5" />
          </button>
        </div>

        <button
          type="button"
          class="cursor-pointer min-h-8 min-w-8 py-2 px-2 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-full last:rounded-e-full border border-gray-400 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-700 dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
          @click="onClickPage(options.pag + 1)">
          <ChevronRightIcon class="shrink-0 size-3.5" />
        </button>
      </template>
    </nav>
  </div>
</template>
<script setup lang="ts">
import { watch, ref } from 'vue'
import { ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/vue/24/outline'
import type { IPaginationOptions } from '@/modules/Core/interfaces';
const classActive = "cursor-pointer min-h-[32px] min-w-8 flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-400 py-1 px-2.5 text-sm first:rounded-s-full last:rounded-e-full focus:outline-none focus:bg-gray-300 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-600 dark:border-gray-700 dark:text-white dark:focus:bg-gray-500"
const classInactive = "cursor-pointer min-h-[32px] min-w-8 flex justify-center items-center border border-gray-400 text-gray-800 hover:bg-gray-100 py-1 px-2.5 text-sm first:rounded-s-full last:rounded-e-full focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-700 dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
const props = defineProps<{
  options: IPaginationOptions
}>()
const emit = defineEmits(['cambiarPagina'])
const options = ref(props.options)
const ultimos = ref([] as number[])
watch(props.options, (nuevo) => {
  ultimos.value = []
  options.value = nuevo
  for (let index = options.value.countPag; index >= (options.value.countPag - 8); index--) {
    ultimos.value.unshift(index)
  }
}, { immediate: true, deep: true })
function onClickPage(value: number) {
  emit('cambiarPagina', value)
}

</script>
